// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.v-subheader.theme--light {\n  font-weight: bold !important;\n  color: black !important;\n  font-size: medium !important;\n}\n", ""]);
// Exports
module.exports = exports;
